<template>
  <el-dialog
    class="modal-modify-platform"
    :title="title"
    :visible.sync="visible"
    @close="$_cancle"
    lock-scroll
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    custom-class="greater"
  >
    <div class="content">
      <el-form
        ref="modifyPlatform"
        :rules="rules"
        v-loading="isLoading"
        label-position="right"
        :model="formData"
        class="platform-modify__form"
      >
        <el-form-item label="父组织名称:" prop="parentName" v-if="!isYys">
          <el-input v-model="formData.parentName" placeholder="必填" style="width: 440px;" disabled></el-input>
        </el-form-item>
        <el-form-item label="组织名称:" prop="orgName">
          <el-input :disabled="isYys" v-model="formData.orgName" placeholder="必填" style="width: 440px;"></el-input>
          <span
            class="input-tips"
          >支持输入最多32个字符，格式不限</span>
        </el-form-item>
        <el-form-item label="组织编码:" prop="orgCode">
          <el-input v-model="formData.orgCode" placeholder="选填" style="width: 440px;"></el-input>
          <span
            class="input-tips"
          >选填，字符长度和格式不限</span>
        </el-form-item>
        <el-form-item label="负责人:" prop="leader">
          <el-input v-model="formData.leader" placeholder="选填" style="width: 440px;"></el-input>
          <span
            class="input-tips"
          >支持输入最多32个字符, 格式不限，多个可用英文“,”隔开</span>
        </el-form-item>

        <el-form-item label="关联门店:" v-if="!isYys" prop="storeNames">
          <el-input
            type="textarea"
            disabled
            v-model="formData.storeNames"
            style="width: 440px; height: 58px;"
            resize="none"
            placeholder="请选择门店, 多选, 必选"
          ></el-input>
          <el-button @click="$_selectStores" class="select__btn" style="vertical-align: top;">选择门店</el-button>
        </el-form-item>

        <el-form-item label="备注:" prop="memo" type="textarea">
          <el-input
            v-model="formData.memo"
            type="textarea"
            resize="none"
            placeholder="选填"
            style="width: 440px; height: 58px;"
          ></el-input>
          <span
            class="input-tips"
          >*最多支持50个字符</span>
        </el-form-item>
      </el-form>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button class="save__btn" @click="$_submit">保存</el-button>
      <el-button class="cancel__btn" @click="$_cancle">取消</el-button>
    </div>

    <!-- 选择门店s弹窗组件 -->
    <select-stores
      v-if="modal.show === true && modal.template === 'select-stores'"
      :title="modal.title"
      :selecteds="modal.data.stores"
      :provinces="provinces"
      :platformKey="platformKey"
      :dataObj="modalData.dataObj"
      :formType="formType"
      @callback="$_callbackStores"
      @close="$_close"
    ></select-stores>
  </el-dialog>
</template>
<script>
import * as Utils from "@/plugins/utils";
import SelectStores from "./modal-select-stores";

export default {
  name: "modal-modify-platform",
  props: {
    platformKey: { type: String, default: "" },
    title: { type: String, default: "" },
    formType: { type: String, default: "add" },
    modalData: { type: Object, default: {} },
    provinces: { type: Array, default: function () {
      return [];
    }},
  },
  data() {
    return {
      visible: false,
      isLoading: false,
      formData: {
        parentName: '',
        orgName: "", // 接口名称
        orgCode: "", // 组织类型
        stores: [], // 保存已选择的门店
        storeNames: "", // 门店名称s
        memo: "", // 备注
        leader: '',//负责人
        storeIds: [],//关联门店id数组
      },
      rules: {
        orgName: [
          { required: true, message: "请输入运营商名称", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              if (value !== "" && value.length > 32) {
                callback(new Error("最多32个字符!"));
              } else {
                callback();
              }
            },
            trigger: "blur"
          },
        ],
        leader: [
          {
            validator: (rule, value, callback) => {
              if (value !== "" && value.length > 32) {
                callback(new Error("最多32个字符!"));
              } else {
                callback();
              }
            },
            trigger: "blur"
          },
        ],
        storeNames: [{ required: true, message: "请选择门店" }],
        memo: [
          {
            validator: (rule, value, callback) => {
              if (value !== "" && value.length > 50) {
                callback(new Error("最多50个字符!"));
              } else {
                callback();
              }
            },
            trigger: "blur"
          },
        ]
      },
      modal: {
        show: false,
        title: "",
        template: "",
        data: {}
      },
    };
  },
  computed: {
    isYys(){
      return this.modalData.dataObj.level == 1 && this.formType=="edit" ? true : false;
    },
    storeNames() {
      if (this.formData.stores.length > 0) {
        return this.formData.stores.reduce(
          (prev, curr) =>
            prev + (prev ? ", " : "") + (curr.storeName || curr.shopName),
          ""
        );
      } else {
        return "";
      }
    }
  },
  methods: {
    $_submit() {
      this.$refs["modifyPlatform"].validate(valid => {
        if (valid) {
          const self = this;
          self.isLoading = true;
          let action = "addOrg";
          let postData = {
            orgName: self.formData.orgName,
            orgCode: self.formData.orgCode,
            leader: self.formData.leader,
            memo: self.formData.memo
          };
          if(!this.isYys || self.formType !== "edit"){
            postData.storeIds=self.formData.storeIds;
          }else{
            postData.orgName = postData.orgName.replace('【运营商】',"");
          }
          if (self.formType === "edit") {
            action = "editOrg";
            postData.id = self.modalData.dataObj.id;
          }else{
            postData.parentId = self.modalData.dataObj.id;
          }
          self.$service.post(action, postData).then(result => {
            self.isLoading = false;
            if (result.$.checkResult(result, true)) {
              $MessageBox.alert({
                content: result.msg,
                onOk() {
                  self.visible = false;
                  self.$emit("callback");
                }
              });
            }
          });
        }
      });
    },

    $_cancle() {
      this.visible = false;
      this.$emit("close");
    },
     // 选择门店s
    $_selectStores() {
      this.modal.data = {
        stores: this.formData.stores.map(item => {
          Object.assign(item, { storeName: item.shopName ? item.shopName : item.storeName, shopId: item.shopId });
          return { ...item };
        })
      };
      this.modal.title = "选择门店";
      this.modal.template = "select-stores";
      this.modal.show = true;
    },
    // 选择门店s回调
    $_callbackStores(data) {
      this.formData.stores.splice(0);
      this.formData.stores = data.concat([]);
      this.formData.storeNames = this.formData.stores.reduce(
        (prev, curr) =>
          prev + (prev ? ", " : "") + (curr.storeName || curr.shopName),
        ""
      );
      this.formData.storeIds = this.formData.stores.reduce(
        (prev, curr) => prev.concat([curr.shopId]),
        []
      );
    },
    // 关闭弹窗
    $_close() {
      this.modal.show = false;
      this.modal.template = "";
      this.modal.title = "";
      this.modal.data = {};
    },
  },
  async created() {
    
    if (this.formType === "edit") {
      if (this.modalData.dataObj.parentId != 0) {
        this.formData.parentName = this.modalData.list.find(ele => ele.id==this.modalData.dataObj.parentId).orgName;
      }
      this.formData.orgName = this.modalData.dataObj.orgName;
      this.formData.leader = this.modalData.dataObj.leader;
      this.formData.orgCode = this.modalData.dataObj.orgCode;
      this.formData.memo = this.modalData.dataObj.memo || "";
      this.isLoading = true;
      await this.$service.post("getOrgShopDetailList", {
        orgId: this.modalData.dataObj.id,
        pageNow: 1,
        pageSize: 9999
      }).then(result => {
        if (result.$.checkResult(result, true)) {
          this.formData.stores = result.data.rows.concat([]);
          this.formData.storeNames = result.data.rows.map(ele => ele.storeName).join(", ");
          this.formData.storeIds = result.data.rows.map(ele => ele.shopId);
        }
        this.isLoading = false;
      });
    }else{
      this.formData.parentName = this.modalData.dataObj.orgName;
    }
  },
  mounted() {
    this.visible = true;
  },
  components: {
    SelectStores
  }
};
</script>

<style lang="scss" scoped>
.modal-modify-platform {
	.content {
		padding: 20px 30px;
    height: 100%;
		.title {
			height: 32px;
			color: #384e8c;
			font-size: 14px;
			font-weight: 700;
		}
	}
}
.select__btn {
  margin: 0 0 0 10px;
  width: 80px;
  height: 30px;
  line-height: 30px;
}
.input-tips{
  margin-left:10px;
  vertical-align: top;
}
/deep/ .el-textarea__inner{
  word-break: break-word;
}
</style>


